import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";
import { Box, Button, Text } from "rebass";
import { toastr } from "react-redux-toastr";

import { getActiveRecordText } from "../../../store/modules/library/selectors";

import { SpinnerSVG } from "../svg/SpinnerSVG";

const wrapperCSS = css`
  position: relative;
  padding: 18.5px 21px;
  transition: all .4s;
  text-align: unset;
`;

const spinnerCSS = css`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
`;

export const CopyContentControl: React.FC = () => {
  const [isCopying, setIsCopying] = useState(false);
  const contentText = useSelector(getActiveRecordText);
  const copyToClipboard = useCallback(() => {
    const { clipboard } = navigator;

    if (contentText) {
      clipboard.writeText(contentText)
        .then(() => {
          toastr.success("Copy text", "Copied");
        })
        .catch(({ message }) => {
          toastr.error("Copy text", message);
        })
        .finally(() => {
          setIsCopying(false);
        })
    }
  }, [contentText]);

  return (
    <Button
      type="button"
      width="100%"
      color={contentText ? "sp-blue" : "hoki"}
      bg={contentText ? "transparent" : "hoki-25"}
      borderRadius="0"
      css={wrapperCSS}
      disabled={!contentText || isCopying}
      onClick={copyToClipboard}
    >
      <Text textAlign="left">Copy text</Text>

      {isCopying && (
        <Box
          color="sp-blue"
          css={spinnerCSS}
        >
          <SpinnerSVG size={20} />
        </Box>
      )}
    </Button>
  );
};
